import { ResumenDeLaCotizacion } from '@/modules/cotizaciones/hoja/ResumenDeLaCotizacion'
import { useOrdenServicio } from '@/modules/ordenes-servicio/useOrdenesServicio'

/**
 * QUÉ LLEVA LA COTIZACIÓN, DESPLEGADO EN LA MISMA CARTA.
 *
 * Desde «Esperando su decisión» se aprobaba y se le mandaba al cliente viendo
 * solo el cliente y el total. Johan pidió el previo aquí mismo; la primera
 * versión abría la hoja entera —la del formato de World Office, con su botón de
 * imprimir— y él lo corrigió dos veces: «no quiero que se abra el PDF» y «puede
 * ser expandible así».
 *
 * Tiene razón las dos veces. Para decidir si el precio está bien no hace falta
 * el papel membretado ni salir de la pantalla: hace falta ver QUÉ LLEVA y
 * CUÁNTO, ahí donde se está decidiendo. El documento sigue estando en la orden
 * para quien lo necesite en papel.
 *
 * Es la misma lista que se lee en la ficha de la orden —misma consulta, mismos
 * totales—, no un cálculo aparte.
 *
 * La orden se pide solo al desplegar: traer los renglones de todas las cartas
 * por si acaso sería pedir de más en la pantalla que más se mira.
 */
export function VistaPreviaCotizacion({ ordenServicioId }: { ordenServicioId: string }) {
  const { orden } = useOrdenServicio(ordenServicioId)

  if (!orden) return null

  return <ResumenDeLaCotizacion orden={orden} />
}
